import { SelectProps } from 'antd/lib'

import { useDefaultSortingItem } from 'src/hooks'
import { useLocales } from 'src/locales'

export const useConfig = () => {
  const { t } = useLocales()
  const { defaultSortingOption } = useDefaultSortingItem()

  const orderingOptions: SelectProps['options'] = [
    defaultSortingOption,
    {
      value: 'Name',
      label: t('roles.name_asc')
    },
    {
      value: '-Name',
      label: t('roles.name_desc')
    }
  ]

  return { orderingOptions }
}
